import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import title from "../images/title.png"

const Header = ({ siteTitle }) => (
  <header id="header" >

      <div className="logo">
        <Link to="/" >
          <img src={title} alt={siteTitle} classname="logoImage" style={{backgroundColor:'#ffffff', width:'100%'}}/>
        </Link>
      </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
